import React from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { dataSlice } from '../../../redux/slices'
import { selectDataSelectionMode } from '../../../redux/slices/dataSlice'
import {
  DataSearchResponseItem,
  DataSearchResponseItemVersion
} from '../../../services/endpoints/data'
import { getFileSize } from '../../../utils/helpers'
import './ResultsGridColData.css'
interface ResultsGridDataColProps {
  key: DataSearchResponseItem
}

export const ResultsGridDataCol: React.FC<ResultsGridDataColProps> = ({
  key
}) => {
  return (
    <div className="dataset-display">
      {key.versions.map((i) => (
        <_Row key={`ResultGridDataColRow-${i.id}`} data={i} />
      ))}
    </div>
  )
}

export const _Row: React.FC<{ data: DataSearchResponseItemVersion }> = ({
  data
}) => {
  const { selected, type, size, archived, checkedOut } = useAppSelector(
    (state) => state.data.versions[data.id]
  )
  const { hasLocalSelected, hasNonLocalSelected } = useAppSelector(
    selectDataSelectionMode
  )
  const dispatch = useDispatch()

  const isLocal = !archived || !!checkedOut

  const isDisabledForSelection =
    !selected &&
    ((isLocal && hasNonLocalSelected) || (!isLocal && hasLocalSelected))

  const handleClick = () => {
    // Prevent mixing local and non-local selections when adding a new selection
    if (!selected) {
      if (isLocal && hasNonLocalSelected) {
        return
      }
      if (!isLocal && hasLocalSelected) {
        return
      }
    }

    dispatch(dataSlice.actions.toggleVersion(data.id))
  }

  return (
    <button
      className={`data-type-button ${selected ? 'active' : ''} ${
        isDisabledForSelection ? 'disabled' : ''
      } ${!isLocal ? 'non-local' : ''}`}
      onClick={handleClick}
      disabled={isDisabledForSelection}
    >
      {!isLocal && (
        <span
          className="cold-storage-indicator"
          title="Archived in cold storage"
          aria-label="Archived in cold storage"
        >
          <span className="glyphicons glyphicons-cloud" />
        </span>
      )}
      <div className="data-type-extension">{type.toUpperCase()}</div>
      <div className="data-type-size">{getFileSize(size)}</div>
    </button>
  )
}
